import React, { useEffect, useState } from "react";
import { Modal } from "../../../../../components/modal.jsx";
import { StepUpload } from "./importModal/fileImport/stepUpload.jsx";
import { StepMapping } from "./importModal/fileImport/stepMapping.jsx";
import { StepConfirm } from "./importModal/fileImport/stepConfirm.jsx";
import { useModal } from "../../../../../hooks/useModal.js";
import * as PropTypes from "prop-types";
import { StepSource } from "./stepSource.jsx";
import { StepAccountList } from "./importModal/bankImport/stepAccountList.jsx";
import { StepAccountAdd } from "./importModal/bankImport/stepAccountAdd.jsx";
import { useSearchParams } from "react-router-dom";
import { StepAccountSync } from "./importModal/bankImport/stepAccountSync.jsx";

export let TRANSACTION_IMPORT_MODAL = "importTransaction";

StepSource.propTypes = { setMode: PropTypes.func };

StepAccountAdd.propTypes = {
  bank: PropTypes.shape({ step: PropTypes.string }),
  setBank: PropTypes.func,
};

StepAccountSync.propTypes = {
  bank: PropTypes.shape({ step: PropTypes.string }),
  setBank: PropTypes.func,
};

export function TransactionImportModal({ pagination }) {
  let [search, setSearch] = useSearchParams();
  let [mode, setMode] = useState(null);
  let [file, setFile] = useState({ step: "upload" });
  let [bank, setBank] = useState({ step: "list" });
  let { closeModal } = useModal();

  useEffect(() => {
    if (search.get("fromAccountCallback")) {
      setMode("bank");
      setSearch({});
    }
  }, [search, setSearch]);

  return (
    <Modal
      fullPage={file.step === "mapping"}
      onClose={() => closeModal(TRANSACTION_IMPORT_MODAL)}
    >
      {mode === "file" && (
        <>
          {file.step === "upload" && <StepUpload setFile={setFile} />}
          {file.step === "mapping" && (
            <StepMapping file={file} setFile={setFile} />
          )}
          {file.step === "confirm" && (
            <StepConfirm
              file={file}
              setFile={setFile}
              pagination={pagination}
            />
          )}
        </>
      )}
      {mode === "bank" && (
        <>
          {bank.step === "list" && (
            <StepAccountList bank={bank} setBank={setBank} />
          )}
          {bank.step === "sync" && (
            <StepAccountSync
              bank={bank}
              setBank={setBank}
              pagination={pagination}
            />
          )}
          {bank.step === "add" && (
            <StepAccountAdd bank={bank} setBank={setBank} />
          )}
        </>
      )}
      {!mode && (
        <>
          <StepSource setMode={setMode} />
        </>
      )}
    </Modal>
  );
}
